import styled from 'styled-components';
import { Text } from '@spotify-internal/encore-web';
import { TWO_COLUMN_MAX_WIDTH } from '../Grid';
export const Eyebrow = styled(Text).attrs({
    variant: 'bodyMedium',
    className: 'eyebrow',
}) `
  text-align: ${({ centered }) => (centered ? 'center' : 'start')};
  text-transform: uppercase;
  display: block;
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    font-size: 14px;
  }
`;
